var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"coupon-page"},[_c('div',{staticClass:"title"},[_vm._v("我的优惠券")]),_c('div',{staticClass:"coupon-box"},_vm._l((_vm.coupons),function(item,index){return _c('CouponItem',{key:index,attrs:{"item":item}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }